module.exports = __webpack_public_path__ + "img/bottom_icon9.bd7ceb3c_bd7ceb3c09eae6915d586b1b4f850c1d.bd7ceb3c.png";